import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { CiCirclePlus } from "react-icons/ci";
import bgImage from "./assets/bg1.png";

import { useNavigate } from "react-router-dom";

const PreviousExperience = ({ userId }) => {
  const schema = yup.object().shape({
    // organisation: yup.string().required("Organisation is required"),
    // period_from: yup.string().required("Period From is required"),
    // period_to: yup.string().required("Period To is required"),
    // designation: yup.string().required("Designation is required"),
    // designation_of_immediate_superior: yup
    //   .string()
    //   .required("Designation of Immediate Superior is required"),
    // last_salary: yup.string().required("Last Salary Drawn is required"),
    // reason_for_leaving: yup.string().required("Reason for Leaving is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  const onSubmit = async (formData) => {
    try {
      const finalObj = { ...formData, userId };
      const token = localStorage.getItem("token");

      if (!token) {
        toast.error("user unauthorized.");
        return;
      }
      const response = await fetch(
        " http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/previousExperience",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(finalObj),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      toast.success("Previous Experience Details Submitted Successfully!", {
        position: "top-center",
        transition: Slide,
      });
      reset(); // Reset form after successful submission
      setTimeout(() => {
        navigate("/EnteryCandidatePortel/Additional-Information");
      }, 2000); // 1 second delay
    } catch (error) {
      toast.error("Error submitting form. Please try again.");
      console.error("Error:", error);
    }
  };

  return (
    <div
    className="w-full flex items-center justify-center"
    style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}
    >
      <ToastContainer transition={Slide} />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-6xl mx-auto bg-white p-8 shadow-lg rounded-lg items-center"
      >
        <h1 className="w-full text-3xl font-serif font-bold text-center my-6 text-indigo-600 mt-3 ">
          PREVIOUS EXPERIENCE
        </h1>
        <h1 className="text-xl font-serif font-bold text-center my-6 text-indigo-600">(If you are a fresher, please fill 'N/A' as the response for the mandatory field below)</h1>
        <div className=" border-b-2 border-indigo-400 mb-4  mx-2 "></div>
        <table className="table-auto w-full divide-y divide-gray-200 mt-3">
          <thead className="bg-white">
            <tr>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left px-2"
                rowSpan="2"
              >
                ORGANISATION
              </th>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left"
                colSpan="2"
              >
                PERIOD
              </th>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left"
                rowSpan="2"
              >
                DESIGNATION
              </th>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left"
                rowSpan="2"
              >
                Previous HR/Manager Name
              </th>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left"
                rowSpan="2"
              >
               DESIGNATION OF Immediate SUPERIOR EMAIL ID
              </th>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left"
                rowSpan="2"
              >
                LAST SALARY 
              </th>
              <th
                className="w-2/12 py-2 font-serif text-black font-bold text-xs text-left pr-9"
                rowSpan="2"
              >
                REASON FOR LEAVING
              </th>
            </tr>
            <tr>
              <th className="w-1/12 py-2 font-serif text-black font-bold text-xs text-left">
                FROM
              </th>
              <th className="w-1/12 py-2 font-serif text-black font-bold text-xs text-left">
                TO
              </th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200 mx-2">
            <tr>
              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("organisation")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.organisation && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.organisation.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("period_from")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {/* {errors.period_from && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.period_from.message}
                  </p>
                )} */}
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("period_to")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {/* {errors.period_to && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.period_to.message}
                  </p>
                )} */}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("designation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.designation && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.designation.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  {...register("name")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.name && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.name.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("Superior_Email_Id")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Superior_Email_Id && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Superior_Email_Id.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("last_salary")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.last_salary && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.last_salary.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("reason_for_leaving")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.reason_for_leaving && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.reason_for_leaving.message}
                  </p>
                )}
              </td>
            </tr>
            <tr>
              <td className="py-2">
                <input
                  type="text"
                  {...register("Second_organisation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_organisation && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_organisation.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("Second_period_from")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_period_from && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_period_from.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("Second_period_to")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_period_to && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_period_to.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("Second_designation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_designation && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_designation.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  {...register("Second_name")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_designation_of_immediate_superior && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_designation_of_immediate_superior.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("Second_Superior_Email_Id")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_designation_of_immediate_superior && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_designation_of_immediate_superior.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("Second_last_salary")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_last_salary && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_last_salary.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("Second_reason_for_leaving")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_reason_for_leaving && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_reason_for_leaving.message}
                  </p>
                )}
              </td>
            </tr>

            <tr>
              <td className="py-2">
                <input
                  type="text"
                  {...register("third_organisation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_organisation && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_organisation.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("third_period_from")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_period_from && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_period_from.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("third_period_to")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_period_to && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_period_to.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("third_designation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_designation && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_designation.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  {...register("third_name")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_designation_of_immediate_superior && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_designation_of_immediate_superior.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  {...register("third_Superior_Email_Id")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_designation_of_immediate_superior && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_designation_of_immediate_superior.message}
                  </p>
                )}
              </td>

              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("third_last_salary")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
                {errors.Second_last_salary && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.Second_last_salary.message}
                  </p>
                )}
              </td>
              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("third_reason_for_leaving")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
            </tr>

            <tr>
              <td className="py-2 mt-10">
                <input
                  type="text"
                  {...register("four_organisation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("four_period_from")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
              <td className="py-2">
                <input
                  type="date"
                  {...register("four_period_to")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("four_designation")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>

              <td className="py-2">
                <input
                  type="text"
                  {...register("four_name")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  {...register("four_Superior_Email_Id")}
                  placeholder="Your answer"
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>

              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("four_last_salary")}
                  className="w-28 px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
              <td className="py-2">
                <input
                  type="text"
                  placeholder="Your answer"
                  {...register("four_reason_for_leaving")}
                  className="w-full px-1 py-1 border rounded-md focus:outline-none focus:border-indigo-500"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div className="w-full flex justify-center  mb-3">
          <button
            type="submit"
            className="w-28 py-2 px-4 bg-green-600 text-white rounded-md mt-5"
          >
            Submit
          </button>
        </div>
        
      </form>
    </div>
  );
};

export default PreviousExperience;
